import { defineEmits } from "vue";
import type { BannerProps } from './type'

export function useBannerHook() {
  const openCatalog = ref<boolean>(false)
  const router = useRouter()

  function handleOpenCatalog() {
    openCatalog.value = true
  }

  function handleBack() {
    router.back()
  }

  function handleHome() {
    router.push('/mall')
  }

  function handleSecurity() {
    // console.log(emit)
    // emit("back:security");
  }


  function handleLeftClick(func: BannerProps['func']) {
    switch (func) {
      case 'back':
        handleBack()
        break
      case 'menu':
        handleOpenCatalog()
        break
      case 'home':
        handleHome()
        break
      case 'none':
        break
      case 'security':
        handleSecurity()
        break
      default:
        router.back()
        break;
    }
  }

  return {
    openCatalog,
    handleLeftClick,
  }
}
